import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-prototype-file",
  "use": "icon-prototype-file-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-prototype-file\"><path fill=\"currentcolor\" fill-opacity=\".85\" fill-rule=\"evenodd\" d=\"M1.5 14.5h13v-13h-13zM6 5zh7V3H3v2zm0 1.5H3V13h3zm1.5 0H13V13H7.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol